import ContentsDescription from './ContentsDescription';
import ImageArea from './ImageArea';
import TeaxtArea from './TextArea';

ContentsDescription.TextArea = TeaxtArea;
ContentsDescription.ImageArea = ImageArea;

export default ContentsDescription;
